import React, { useState } from "react";
import "./cvcard.css";

const CVcard = ({ blog: { title, name_, dept, category, cover, company, profilecolor, thumbnail }, index, blogs }) => {
  const [dialog, setDialog] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(index);
  const [coverImage, setCoverImage] = useState(cover);
  const [name, setName] = useState(company);
  const [dept_, setDept] = useState(dept);
  const [category_, setCategory] = useState(category);

  // Ensure category is lowercase for styling matching
  const categoryKey = category ? category.toLowerCase() : "other";

  const toggleDialog = () => {
    setDialog(!dialog);
    updateModalState(index);
  };

  const updateModalState = (idx) => {
    const blog = blogs[idx];
    setCurrentIndex(idx);
    setCoverImage(blog.cover);
    setName(blog.company);
    setDept(blog.dept);
    setCategory(blog.category);
  };

  const nextCard = (e) => {
    e.stopPropagation();
    const nextIndex = (currentIndex + 1) % blogs.length;
    updateModalState(nextIndex);
  };

  const prevCard = (e) => {
    e.stopPropagation();
    const prevIndex = (currentIndex - 1 + blogs.length) % blogs.length;
    updateModalState(prevIndex);
  };

  return (
    <>
      <div className="cv-card" data-category={categoryKey} onClick={toggleDialog}>
        <div className="cv-preview">
          <img src={thumbnail} alt={`${name_}'s CV`} loading="lazy" />
        </div>
        <div className="cv-info">
          <div className="cv-name">{name_}</div>
          <div className="cv-role">{company}</div>
          <div className="cv-details">
            <div>{dept}</div>
            {/* You could add more details here if available, e.g. Year */}
          </div>
          <span className="cv-tag" style={{ textTransform: 'capitalize' }}>{category}</span>
          <button className="view-btn">View Full CV</button>
        </div>
      </div>

      {dialog && (
        <div className="dialog" onClick={toggleDialog}>
          <button onClick={prevCard} className="arrow-button left">
            &#9001;
          </button>
          
          <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
            <button onClick={toggleDialog} className="close-icon">
              &times;
            </button>

            <ImageModal cover={coverImage} name={name} dept_={dept_} />
          </div>

          <button onClick={nextCard} className="arrow-button right">
            &#9002;
          </button>
        </div>
      )}
    </>
  );
};

const ImageModal = ({ cover, name, dept_ }) => {
  return (
    <div className='image-modal'>
      <div className='cvname'>
        <h3>
          {name} | {dept_}
        </h3>
      </div>
      <img src={cover} alt='Full CV' />
    </div>
  );
};

export default CVcard;
